// Extras en inglés: etiquetas del desplegable de necesidad (por posición),
// FAQ de la home, guías "en preparación" (por posición) y categorías.

export const needLabelsEn = [
  "Measure a plot or piece of land",
  "Topographic survey",
  "Plot georeferencing",
  "GML file for Catastro / Land Registry",
  "Check or mark boundaries",
  "Correct Catastro data",
  "Divide a plot into two or more parcels",
  "Merge several plots into one",
  "Check a plot before buying",
  "Declare new construction",
  "Declare an extension",
  "Certificate of age",
  "Certificate of habitability",
  "First occupation of a non-conforming building",
  "Consolidated use report",
  "Urban planning information certificate",
  "Official alignment and road levels",
  "Prior notification of works",
  "Major works permit",
  "Horizontal division of a building",
  "Change of use from premises to dwelling",
  "I'm not sure: I want to explain my case",
];

export const homeFaqsEn = [
  {
    q: "Do you work on all the islands?",
    a: "Yes. We carry out measurements and surveys on all seven islands, on rural and urban plots alike. Tell us where the plot is and we'll confirm availability and a quote.",
  },
  {
    q: "How much does it cost to survey a plot?",
    a: "It depends on the surface area, the terrain, access and the available documentation. Every assignment is assessed individually: tell us about your case and we'll prepare a fixed quote upfront, with no obligation.",
  },
  {
    q: "Is your work valid for Catastro or the Land Registry?",
    a: "Our technical documentation (plans, measurements, GML files, certificates) is the basis these procedures usually require. Final acceptance always belongs to Catastro, the notary or the registrar, and may depend on the specific case.",
  },
  {
    q: "I don't know which service I need. What do I do?",
    a: "That's the most common situation. Tell us your problem in your own words (for example, 'Catastro shows fewer metres' or 'I don't know where my land ends') and we'll tell you what technical work you need, if you need any.",
  },
  {
    q: "Do I need to have the deed or the cadastral reference?",
    a: "It isn't essential for a first enquiry, but it speeds up the assessment a lot. The cadastral reference lets us review the mapping and the registry data before the visit.",
  },
  {
    q: "Do you handle notarial or registry procedures?",
    a: "No. We are a technical service: we measure, document and produce the technical part. Notarial, registry or administrative actions belong to notaries, registrars and administrations, with whom we collaborate when the file requires it.",
  },
];

export const upcomingGuidesEn = [
  { title: "How much does it cost to survey a plot?", category: "Surveying · covered on the prices page" },
];

export const guideCategoriesEn = [
  "Catastro",
  "Land Registry & deeds",
  "Surveying",
  "Boundaries",
  "GML & georeferencing",
  "Buying & selling",
  "New construction",
  "Age of buildings",
  "Habitability",
  "Energy efficiency",
  "Structure",
  "Planning",
];
